import React from 'react'
import icon_web3 from '../img/technologies/web3.svg'
import icon_ethers from '../img/technologies/ethers.svg'
import icon_tonweb from '../img/technologies/tonweb.svg'
import icon_node from '../img/technologies/node.svg'
import icon_chia from '../img/technologies/chia.svg'
import icon_mocha from '../img/technologies/mocha.svg'
import icon_hardhat from '../img/technologies/hardhat.svg'
import icon_truffle from '../img/technologies/truffle.svg'

export default function TechCards() {
  
  const cards = [
    { id: 1, img: icon_web3, text: 'Web3.js' },
    { id: 2, img: icon_ethers, text: 'Ethers.js' },
    { id: 3, img: icon_tonweb, text: 'Tonweb.js' },
    { id: 4, img: icon_node, text: 'Node.js' },
    { id: 5, img: icon_chia, text: 'CHIA' },
    { id: 6, img: icon_mocha, text: 'MOCHA' },
    { id: 7, img: icon_hardhat, text: 'Hardhat' },
    { id: 8, img: icon_truffle, text: 'Truffle' }
  ];
  
  return (
    <div className="tech-cards">
      {cards.map((card) => (
        <div className='tech-card'>
          <img src={card.img} alt={card.text} />
          <span>{card.text}</span>
        </div>
      ))}
    </div>
  )
}
